"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BrowserLanguageProvider = /** @class */ (function () {
    function BrowserLanguageProvider() {
    }
    /**
     * Obtains the default language of the browser
     */
    BrowserLanguageProvider.prototype.get = function () {
        var conversationLanguage = navigator.language;
        console.log("Detected browser language " + conversationLanguage);
        return conversationLanguage;
    };
    BrowserLanguageProvider.prototype.toString = function () {
        return "Class [" + BrowserLanguageProvider.name + "] with value: " + this.get();
    };
    return BrowserLanguageProvider;
}());
exports.BrowserLanguageProvider = BrowserLanguageProvider;
